<template>
  <div class="form-module-wrapper">
    <div class="form-module">
      <div class="container">
        <div class="title">多边框选详情</div>
        <button class="close-btn" @click="sendDataToParent('close')">×</button>
      </div>
      <div class="form-container">
        <div class="table">
          <!-- 菜单 -->
          <a-menu v-model="current" mode="horizontal" style="margin-bottom: 20px;" @click="handleMenuClick">
            <a-menu-item key="marker">
              <a-icon type="environment" />管点
            </a-menu-item>
            <a-menu-item key="line">
              <a-icon type="line" />管线
            </a-menu-item>
          </a-menu>

          <div class="button">
            <!-- <a-button type="primary" style="margin-right: 10px;">
              过滤设置
            </a-button> -->
            <a-button type="primary" style="margin-right: 10px;" @click="checkError" :loading="errorChecking">
              数据查错
            </a-button>
            <a-button type="danger" @click="batchDeletion">
              批量删除
            </a-button>
          </div>

          <!-- 动态表格 -->
          <a-table :rowKey="(record, index) => record.id" :columns="currentColumns" :data-source="currentData"
            style="width: 532px; " :pagination="pagination" size="small" @change="handleTableChange"
            :scroll="{ y: 185 }"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: 32 }"
            class="custom-table">
            <a slot="name" slot-scope="text">{{ text }}</a>
            <span slot="action" slot-scope="text, record">
              <a style="margin-right: 5px;" @click="editorData(record)">编辑</a>
              <a-popconfirm title="确定要删除吗？" ok-text="确定" cancel-text="取消" @confirm="() => delData(record)">
                <a href="javascript:;" style="color: #ff4d4f;" @click="delFormShow">删除</a>
              </a-popconfirm>
            </span>
          </a-table>
        </div>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div v-if="isDisabled" class="overlay"></div>
  </div>
</template>

<script>
export default {
  name: 'PolygonModule',
  props: {
    polygonQueryData: Object, //框选查询数据
    polygonQueryRefresh: Number
  },
  watch: {
    polygonQueryData (newVal, oldVal) {
      this.queryBoxSelectApi(newVal);
    },
    polygonQueryRefresh (newVal) {
      if (newVal != 0) {
        this.queryBoxSelectApi(this.polygonQueryData);
      }
    }
  },
  data () {
    return {
      /**表单基础信息 */
      form: {},
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      selectedRowKeys: [], // 选中的行
      current: ['marker'], // 当前选中的菜单项，默认选中管点
      queryBoxSelectUrl: '/gis-manager/diagramming/project/multi/border', //框选查询管点 管线
      errorCheckUrl: '/gis-manager/diagramming/project/data/checking', // 数据查错接口
      errorChecking: false, // 数据查错加载状态
      // 管点表格列和数据
      columnsPoint: [
        // { title: '序号', dataIndex: 'key', width: 50 },
        { title: '物探点号', dataIndex: 'intuitionPoint' },
        // { title: '口径', dataIndex: '口径' },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } },
      ],
      dataPoint: [

      ],
      // 管线表格列和数据
      columnsLine: [
        // { title: '序号', dataIndex: 'key', width: 50 },
        { title: '连接点号', dataIndex: 'connectionPointNumber' },
        { title: '被连接点号', dataIndex: 'theDotNumberIsConnected' },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } },
      ],
      dataLine: [

      ],
      pagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['5', '10', '20', '30', '40', '50'],
        showLessItems: true, // 减少显示的页码数量
        size: 'small',

      },
      isDisabled: false, // 控制是否禁用操作
    };
  },
  computed: {
    // 动态绑定当前表格的列
    currentColumns () {
      return this.current[0] === 'marker' ? this.columnsPoint : this.columnsLine;
    },
    // 动态绑定当前表格的数据
    currentData () {
      return this.current[0] === 'marker' ? this.dataPoint : this.dataLine;
    },
  },
  methods: {
    // 发送给父组件信息
    sendDataToParent (item) {
      // 触发自定义事件 'child-to-parent'，并传递数据
      this.$emit('polygon-to-parent', item);
    },
    // 提交表单
    onSubmit () {
      console.log(this.form);
      // 通知父组件删除表单组件
      this.sendDataToParent('close');
    },
    // 表格行选择变化
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    // 菜单点击事件
    handleMenuClick (e) {
      this.current = [e.key]; // 更新当前选中的菜单项
      this.sendDataToParent({ type: 'toggle' });
      this.selectedRowKeys = [];
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, current: pagination.current, pageSize: pagination.pageSize }

    },
    //查询列表
    queryBoxSelectApi (parameter) {
      this.$http.post(this.queryBoxSelectUrl, parameter).then(res => {
        this.dataPoint = res.data.pipePointInfoPcList
        this.dataLine = res.data.pipelineInfoPcList
      })
    },
    delData (item) {
      this.sendDataToParent({
        type: 'del' + this.current[0],
        data: item
      });
    },
    delFormShow () {
      this.sendDataToParent({ type: 'toggle' });
    },
    editorData (item) {
      console.log(item);
      this.sendDataToParent({
        type: this.current[0],
        data: item
      });
    },
    //批量删除
    batchDeletion () {
      console.log(this.selectedRowKeys);
      this.sendDataToParent({
        type: 'batchDel' + this.current[0],
        data: this.selectedRowKeys
      });
    },
    // 数据查错功能
    checkError () {
      if (!this.polygonQueryData || !this.polygonQueryData.pointList) {
        this.$message.error('没有可用的框选坐标信息');
        return;
      }

      this.errorChecking = true;

      // 构建请求参数
      const params = {
        errorCheckConditions: 3,
        errorCheckRange: 2,
        projectManagementId: this.polygonQueryData.projectManagementId,
        pointList: this.polygonQueryData.pointList
      };

      // 发送数据查错请求
      this.$http.post(this.errorCheckUrl, params)
        .then(res => {
          if (res.code === 0) {
            this.$message.success('数据查错完成');

            // 查错完成后，通知父组件显示ToolbarModule的数据查错详细列表
            // 根据当前选中的标签页确定要显示的数据类型（管点或管线）
            const activeTab = this.current[0] === 'marker' ? 'point' : 'line';

            // 发送事件给父组件，传递查错结果数据和要显示的标签页类型
            this.sendDataToParent({
              type: 'showErrorCheckResults',
              data: res.data,
              activeTab: activeTab
            });
          } else {
            this.$message.error(res.message || '数据查错失败');
          }
        })
        .catch(error => {
          console.error('数据查错请求失败:', error);
          this.$message.error('数据查错请求失败');
        })
        .finally(() => {
          this.errorChecking = false;
        });
    }
  },
};
</script>

<style lang="less" scoped>
.form-module-wrapper {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* 半透明遮罩 */
  z-index: 1000;
  /* 确保遮罩层在最上层 */
  pointer-events: all;
  /* 阻止点击事件 */
}

.form-module {
  padding: 2px 9px;
  caret-color: transparent;
}

/* 容器样式 */
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
}

.title {
  flex: 1;
  font-size: 15px;
  padding-left: 10px;
}

.close-btn {
  cursor: pointer;
  font-size: 25px;
  color: #5e5c5c;
  background: none;
  border: none;
  padding: 0 7px;
}

.close-btn:hover {
  color: #c00;
}

/* 表单容器 */
.form-container {
  // margin-top: 10px;
  display: flex;
  flex-direction: column;
  height: 400px;
  width: 530px;

  .button {
    width: 100%;
    padding-bottom: 10px;

  }
}


/* 表单内容 */
.form {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 10px;
}

/* 底部按钮 */
.form-buttons {
  padding: 10px;
  border-top: 1px solid #ccc;
  text-align: right;
}

/deep/ .ant-form-item-label>label {
  font-size: 12px;
}

.picker {
  min-width: 162px !important;
  width: 150px;
}

.dropdown {
  position: absolute;
  z-index: 1000;
  width: 150px;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;

  .dropdown-radio {
    position: sticky;
    top: 0;
    width: 100%;
    overflow-x: auto;
  }

  .radio-group {
    display: flex;
    flex-wrap: wrap;
  }

  .radio-button {
    flex: 1 1 50%;
    box-sizing: border-box;
    text-align: center;
    line-height: 30px;
  }
}

.coordinateEditor {
  margin: 0;
}

.table {
  margin-top: 10px;
}

/deep/ .ant-table-thead>tr>th {
  background-color: #fafafa !important;
  text-align: center;
  line-height: 8px;
}

/deep/ .ant-table-tbody>tr>td {
  text-align: center;
  line-height: 20px;
}

/deep/ .ant-table-content {
  height: 220px;
}
</style>